module.exports = __webpack_public_path__ + "assets/img/title-edb1cd8f.png";